import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';

@Injectable()
export class PreviousRouteService {

	private unsubscribe$ = new Subject<void>();

	private previousUrl: string;
	private currentUrl: string;

	constructor(private router: Router) {
		this.currentUrl = this.router.url;
		router.events
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(event => {
			if (event instanceof NavigationEnd) {        
				this.previousUrl = this.currentUrl;
				this.currentUrl = event.url;
			};
		});
	}

	public getPreviousUrl() {
		return this.previousUrl;
	}


	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}    
}